import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { scenario } from './scenario.reducer';
const rootReducer = combineReducers({
  authentication,
  scenario,
  users
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js